import * as Types from '../../../../../../../__generated__/types.gqlgenerated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SaveJobButtonQueryVariables = Types.Exact<{
  jobKey: Types.Scalars['ID']['input'];
}>;


export type SaveJobButtonQuery = { __typename?: 'Query', jobData: { __typename?: 'JobDataPayload', results: Array<{ __typename?: 'JobDataResult', job: { __typename?: 'Job', key: string, savedJob?: { __typename?: 'SavedJob', state: Types.SavedJobState } | null } }> } };

export type UpdateSavedJobStateMutationVariables = Types.Exact<{
  jobKey: Types.Scalars['ID']['input'];
  state: Types.SavedJobState;
}>;


export type UpdateSavedJobStateMutation = { __typename?: 'Mutation', updateSavedJobState?: { __typename?: 'UpdateSavedJobStatePayload', savedJob: { __typename?: 'SavedJob', job: { __typename?: 'Job', key: string, savedJob?: { __typename?: 'SavedJob', state: Types.SavedJobState } | null } } } | null };


export const SaveJobButtonDocument = gql`
    query SaveJobButton($jobKey: ID!) {
  jobData(input: {jobKeys: [$jobKey]}) {
    results {
      job {
        key
        savedJob {
          state
        }
      }
    }
  }
}
    `;

/**
 * __useSaveJobButtonQuery__
 *
 * To run a query within a React component, call `useSaveJobButtonQuery` and pass it any options that fit your needs.
 * When your component renders, `useSaveJobButtonQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSaveJobButtonQuery({
 *   variables: {
 *      jobKey: // value for 'jobKey'
 *   },
 * });
 */
export function useSaveJobButtonQuery(baseOptions: Apollo.QueryHookOptions<SaveJobButtonQuery, SaveJobButtonQueryVariables> & ({ variables: SaveJobButtonQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SaveJobButtonQuery, SaveJobButtonQueryVariables>(SaveJobButtonDocument, options);
      }
export function useSaveJobButtonLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SaveJobButtonQuery, SaveJobButtonQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SaveJobButtonQuery, SaveJobButtonQueryVariables>(SaveJobButtonDocument, options);
        }
export function useSaveJobButtonSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SaveJobButtonQuery, SaveJobButtonQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SaveJobButtonQuery, SaveJobButtonQueryVariables>(SaveJobButtonDocument, options);
        }
export type SaveJobButtonQueryHookResult = ReturnType<typeof useSaveJobButtonQuery>;
export type SaveJobButtonLazyQueryHookResult = ReturnType<typeof useSaveJobButtonLazyQuery>;
export type SaveJobButtonSuspenseQueryHookResult = ReturnType<typeof useSaveJobButtonSuspenseQuery>;
export type SaveJobButtonQueryResult = Apollo.QueryResult<SaveJobButtonQuery, SaveJobButtonQueryVariables>;
export const UpdateSavedJobStateDocument = gql`
    mutation UpdateSavedJobState($jobKey: ID!, $state: SavedJobState!) {
  updateSavedJobState(input: {jobKey: $jobKey, state: $state}) {
    savedJob {
      job {
        key
        savedJob {
          state
        }
      }
    }
  }
}
    `;
export type UpdateSavedJobStateMutationFn = Apollo.MutationFunction<UpdateSavedJobStateMutation, UpdateSavedJobStateMutationVariables>;

/**
 * __useUpdateSavedJobStateMutation__
 *
 * To run a mutation, you first call `useUpdateSavedJobStateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSavedJobStateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSavedJobStateMutation, { data, loading, error }] = useUpdateSavedJobStateMutation({
 *   variables: {
 *      jobKey: // value for 'jobKey'
 *      state: // value for 'state'
 *   },
 * });
 */
export function useUpdateSavedJobStateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSavedJobStateMutation, UpdateSavedJobStateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSavedJobStateMutation, UpdateSavedJobStateMutationVariables>(UpdateSavedJobStateDocument, options);
      }
export type UpdateSavedJobStateMutationHookResult = ReturnType<typeof useUpdateSavedJobStateMutation>;
export type UpdateSavedJobStateMutationResult = Apollo.MutationResult<UpdateSavedJobStateMutation>;
export type UpdateSavedJobStateMutationOptions = Apollo.BaseMutationOptions<UpdateSavedJobStateMutation, UpdateSavedJobStateMutationVariables>;